import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { OrderDTO, PaymentDTO, PaymentDTOTransactionTypeEnum } from '@lkp/parking-sdk';
import { Subject, takeUntil } from 'rxjs';
import { FormService } from 'src/app/core/services/form.service';
import { Refund } from 'src/app/core/states/orders/orders.action';

@Component({
    selector: 'app-klarna-refund',
    templateUrl: './klarna-refund.component.html',
    styleUrls: ['./klarna-refund.component.scss'],
    standalone: false
})
export class KlarnaRefundComponent {
  klarnaForm?: FormGroup;
  loading = false;

  readonly onDestroy$ = new Subject<void>();

  constructor(
    readonly dialog: MatDialogRef<KlarnaRefundComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      order: OrderDTO;
      refund: PaymentDTO;
      maxRefund: number;
      orderItemId: number;
    },
    readonly store: Store,
    readonly formBuilder: FormBuilder,
    readonly formService: FormService
  ) {}

  ngOnInit(): void {
    /* Create form */
    this.klarnaForm = this.formBuilder.group({
      refundControl: new FormControl(undefined, [
        Validators.max(this.data.maxRefund),
        Validators.min(0),
      ]),
      refundComment: new FormControl<string | undefined>('', [
        Validators.required,
        this.formService.noWhitespaceValidator,
      ]),
    });
  }

  closeDialog() {
    this.dialog.close();
  }

  handleRefund() {
    this.loading = true;
    if (this.klarnaForm?.valid) {
      const payment: PaymentDTO = {
        paymentMethod: this.data.refund.paymentMethod,
        transactionType: PaymentDTOTransactionTypeEnum.Refund,
        amount: this.klarnaForm.value.refundControl,
        comment: this.klarnaForm.value.refundComment,
      };

      this.store
        .dispatch(
          new Refund(
            this.data.order.orderId!,
            this.data.orderItemId,
            this.data.refund.paymentId!,
            payment
          )
        )
        .pipe(takeUntil(this.onDestroy$))
        .subscribe({
          next: () => {
            this.dialog.close({ success: true });
            this.loading = false;
          },
          error: (error) => {
            console.error('Error refunding order: ', error);
            this.loading = false;
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
